import { render, staticRenderFns } from "./CookiesTerms.vue?vue&type=template&id=d349c86e&scoped=true&"
import script from "./CookiesTerms.vue?vue&type=script&lang=js&"
export * from "./CookiesTerms.vue?vue&type=script&lang=js&"
import style0 from "./CookiesTerms.vue?vue&type=style&index=0&id=d349c86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d349c86e",
  null
  
)

export default component.exports